/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { errorNoInspect } from "../operations/error.js";
export { ConfigureSidewireTransform };
class ConfigureSidewireTransform {
    nodeId;
    sidewirePortName;
    sourceGraphId;
    subwiredSubgraphId;
    constructor(nodeId, sidewirePortName, sourceGraphId, subwiredSubgraphId) {
        this.nodeId = nodeId;
        this.sidewirePortName = sidewirePortName;
        this.sourceGraphId = sourceGraphId;
        this.subwiredSubgraphId = subwiredSubgraphId;
    }
    async apply(context) {
        if (!this.subwiredSubgraphId) {
            return {
                success: false,
                error: "Subwires may only be created to subgraphs",
            };
        }
        const { mutable, apply } = context;
        const inspector = mutable.graphs.get(this.sourceGraphId);
        if (!inspector) {
            return errorNoInspect(this.sourceGraphId);
        }
        const node = inspector.nodeById(this.nodeId);
        if (!node) {
            return {
                success: false,
                error: `Unable to find node "${this.nodeId}" in graph "${this.sourceGraphId}"`,
            };
        }
        const { graph } = context;
        if (!graph.graphs?.[this.subwiredSubgraphId]) {
            return {
                success: false,
                error: `Unable to find subgraph "${this.subwiredSubgraphId}`,
            };
        }
        const configuring = await apply([
            {
                type: "changeconfiguration",
                id: this.nodeId,
                graphId: this.sourceGraphId,
                configuration: { [this.sidewirePortName]: this.subwiredSubgraphId },
            },
        ], "Configuring side wire");
        if (!configuring.success) {
            return configuring;
        }
        return { success: true };
    }
}
//# sourceMappingURL=configure-sidewire.js.map